<div class="w-100">
  <h2 class="mb-5">Education</h2>

  <div
    class="
      resume-item
      d-flex
      flex-column flex-md-row
      justify-content-between
      mb-5
    "
    *ngFor="let item of educationList"
  >
    <div class="resume-content">
      <h3 class="mb-0" *ngIf="item.university">
        {{ item.university }}
      </h3>
      <div class="subheading mb-3" *ngIf="item.course">{{ item.course }}</div>
      <div *ngIf="item.Major">{{ item.Major }}</div>
      <p>{{ item.grades }}</p>
    </div>
    <div class="resume-date text-md-right" *ngIf="item.duration">
      <span class="text-primary">{{ item.duration }}</span>
    </div>
  </div>
</div>
